<div class="uploaded-file flex flex-row align-content-center justify-content-center ">
  <span class="filename white-space-nowrap overflow-hidden  text-overflow-ellipsis">{{file2Upload.name}} </span>
  <p-progressBar *ngIf="uploadState$ | async; let uploadState;" class="flex-grow-1" [value]="(uploadState.progress )" [style]="{'height': '1rem', 'font-size':'0.8rem'}"  ></p-progressBar>
  <button pButton pRipple type="button" icon="pi pi-times" class=" p-button-rounded p-button-danger p-button-text "
  (click)="onCancel()"
  ></button>
</div>
